import {
  PAYMENT_METHODS_REQUEST,
  PAYMENT_METHODS_SUCCESS,
  PAYMENT_METHODS_FAILURE,
  PAYMENT_METHODS_CLEAR,
} from 'app/actions/finances/paymentMethods';

const defaultState = {
  loading: true,
  paymentMethods: {},
  kinds: {},
  foodSupplier: {},
  cashbox: {},
};

const paymentMethods = (state = defaultState, action) => {
  switch (action.type) {
    case PAYMENT_METHODS_REQUEST: {
      return { ...state, loading: true };
    }

    case PAYMENT_METHODS_SUCCESS: {
      return { ...state, ...action.payload, loading: false };
    }

    case PAYMENT_METHODS_FAILURE: {
      return { ...state, loading: false };
    }

    case PAYMENT_METHODS_CLEAR: {
      return defaultState;
    }

    default:
  }
  return state;
};

export default paymentMethods;
